module.exports = __webpack_public_path__ + "img/asiatic-lilly.7caf43dd.jpg";